import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsGelaender,
        updateHandtrailFormGelaender,
        updateHandtrailEndkappeGelaender,
        updateWrapperIndexGelaender
        } from '../../../../store/actions/gelaender';
import {Textfield} from '../../../../module/textField';
import {handlauf_endkappen} from '../../../../../assets/images/data';
import scrollToElement from '../../../../module/scrollToElement';


const Step_4 = (props) => {

    const [handtrail_form, updateHandrailForm] = useState('');


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
    const {
        handtrail_form,
        endkappe
        } = props.data[props.modell_type].form_handrail[0];
    let kappen_wrapper = document.querySelectorAll('.kappenWrapper img');
    let kappen_index = props.data[props.modell_type].wrapper[0].wrapper4;

    //remove check from box
    for (let i = 0; i < kappen_wrapper.length; i++) {
        kappen_wrapper[i].classList.remove('check');
    }
    //add check to box
    if(endkappe && kappen_wrapper[kappen_index]) {
        kappen_wrapper[kappen_index].classList.add('check');
    }

    updateHandrailForm(handtrail_form);

    //scroll to Next Button Container
    if (handtrail_form) scrollToElement();

      //update steps
      if (props.modell_type === 2) props.updateSteps(4);
      if (props.modell_type === 3) props.updateSteps(2);
      else props.updateSteps(3);

      if((handtrail_form && endkappe) || props.data[props.modell_type].allVisitedSteps) {
        //update steps
        if (props.modell_type === 2) props.updateSteps(5);
        if (props.modell_type === 3) props.updateSteps(3);
        else props.updateSteps(4);
        props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue()
      }

   }

   const updateHandtrailForm = ev => {
        let handrail_form = ev.target.value;
        props.updateHandtrailForm(handrail_form);
        updateItems();
   }

   const updateHandtrailEndkappe = ev => {
        let handrail_endkappe = ev.currentTarget.getAttribute('titel');
        let wrapperObject = {
            ident: 4,
            index: ev.currentTarget.getAttribute('index')
         }

        props.updateHandtrailEndkappe(handrail_endkappe);
        props.updateWrapperIndex(wrapperObject);
        updateItems();
   }

   let handlauf_form_options = [
       {titel: 'Rundrohr 33,7 mm'},
       {titel: 'Rundrohr 42,4 mm'},
       {titel: 'Rechteck 40 x 30 mm'},
       {titel: 'Quadraht 45 x 45 mm'}
   ]


    return (
        <div className="step_wrapper">
            {/* <h2 className="step_header">Rohr Durchmesser</h2> */}
              <div className="step_icon_wrapper">
              <h2 className="step_header">Form des Handlaufs</h2>
                <div className="inner_textfield_wrapper">
                  <Textfield
                    label='Bitte wählen'
                    type='text'
                    select
                    rowsMax={1}
                    value={handtrail_form}
                    onChange={updateHandtrailForm}
                    array_options={handlauf_form_options}
                  />
                </div>

                <h2 className='step_header handlauf'>Welches Endstück?</h2>
                <div className="inner-kappen-wrapper">
                    {handlauf_endkappen.map((elem, index) => (
                        <div className="kappenWrapper" onClick={updateHandtrailEndkappe} key={index} index={index} titel={elem.titel}>
                            <img src={elem.imgsrc} alt={elem.titel}/>
                            <p>{elem.titel}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        modell_type: state.gelaenderReducer.modell_type,
        data: state.gelaenderReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      updateHandtrailForm: ev => dispatch(updateHandtrailFormGelaender(ev)),
      updateHandtrailEndkappe: ev => dispatch(updateHandtrailEndkappeGelaender(ev)),
      updateWrapperIndex: ev => dispatch(updateWrapperIndexGelaender(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_4);
